import { LangConstants } from "../../game/Constants";
import { LangRequestJSON } from "./LangRequestJSON";
/**
 * LangLoader.ts
 */
export class LangLoader {
    constructor(wrapperConfig) {
        this.operatorConfig = wrapperConfig.getOperatorConfig();
        this.operatorParams = wrapperConfig.getOperatorParameters();
    }
    load() {
        const request = new LangRequestJSON(LangConstants.GAME_URL, this.operatorParams.getGameId());
        console.log("Game id: " + this.operatorParams.getGameId());
        request.onComplete(this.handleGameComplete, this);
        request.load();
    }
    loadCommon() {
        const request = new LangRequestJSON(LangConstants.COMMON_URL);
        request.onComplete(this.handleCommonComplete, this);
        request.load();
    }
    loadOperator() {
        if (this.operatorConfig.hasLangOverrides()) {
            const request = new LangRequestJSON(LangConstants.OPERATOR_URL, this.operatorConfig.getLangOverridePath() + "/" + this.operatorParams.getGameId());
            request.onComplete(this.handleOperatorComplete, this);
            request.load();
        }
        else {
            this.onComplete();
        }
    }
    handleCommonComplete() {
        //this.loadGame();
    }
    handleGameComplete() {
        this.loadOperator();
    }
    handleOperatorComplete() {
        if (this.onComplete) {
            this.onComplete();
        }
    }
}
//# sourceMappingURL=LangLoader.js.map